import {Controller} from "@/controllers/Controller";

/**
 * Controller for asset API (ms-marketing) : images d'une publication (le fichier est envoyé tel quel dans le corps de la requête)
 */
export class AssetController extends Controller {

    static upload(publicationId, file) {
        return this.requestBuilder("POST", `/marketing/assets/${publicationId}`, true, file, {
            'Content-Type': file.type,
            'x-file-name': encodeURIComponent(file.name),
        });
    }

    // Fichier brut (blob)
    static download(publicationId, fileId) {
        return this.requestBuilder("GET", `/marketing/assets/${publicationId}/${fileId}`, true, undefined, {'Accept': 'application/pdf'});
    }

    static delete(publicationId, fileId) {
        return this.requestBuilder("PATCH", `/marketing/assets/deactivate/${publicationId}/${fileId}`, true);
    }
}
